import BodyScrollPane from './BodyScrollPane'

export default {
  name: 'body-scroll-pane',
  configure: function(config) {
    config.addComponent('body-scroll-pane', BodyScrollPane)
  },
  BodyScrollPane
}
